import { render } from "./UIUX.vue?vue&type=template&id=0bda48f6"
import script from "./UIUX.vue?vue&type=script&lang=js"
export * from "./UIUX.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__